import { Pipe, PipeTransform } from '@angular/core';
import { EditorFieldType } from '../enums/editor-field-type-enum.service';
import { EditorConfig } from '../models/editor-config.model';
import { EditorFieldConfigCombined } from '../models/editor-field-config.model';

@Pipe({
  name: 'transformFieldConfig',
})
export class TransformFieldConfigPipe implements PipeTransform {
  transform(config: EditorFieldConfigCombined, editorConfig?: EditorConfig): EditorFieldConfigCombined {
    if (!config) {
      return null;
    }
    const defaultLabel: string = config.name?.replace(/^./, (text: string) => text.toUpperCase());
    const readonly: boolean = editorConfig?.readonly ? true : config.readonly;
    return {
      ...config,
      useCommaSeparator: config.type !== EditorFieldType.NUMBER ? undefined : config.useCommaSeparator !== false,
      label: config.noLabel ? undefined : config.label ?? defaultLabel,
      placeholder: config.placeholder || config.label || defaultLabel,
      readonly,
      required: readonly ? false : config.required,
    };
  }
}
